import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'

import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons/faCheckCircle'

const CollectionStatus = ({ isCollected, isWaitlisted, reasons }) => {
  if (isCollected) {
    return isWaitlisted ?
      <span className="grade-status">
        <FontAwesomeIcon className="waitlisting" icon={faCheckCircle} /> Waitlisting
      </span>
      :
      <span className="grade-status">
        <FontAwesomeIcon className="collecting" icon={faCheckCircleSolid} /> Collecting
      </span>
  }

  return (
    <span className="grade-status">
      <OverlayTrigger
        placement={'top'}
        overlay={
          <Tooltip id="custom-grade-config">
            {reasons ? reasons.join('\n') : ''}
          </Tooltip>
        }
      >
        <span>
          <FontAwesomeIcon className="not-collecting" icon={faBan} /> Not collecting
        </span>
      </OverlayTrigger>
    </span>
  )
}

export default CollectionStatus
